





export default {
  name: 'SidebarMenuButton',
};
